import { render, staticRenderFns } from "./requestVaccine.vue?vue&type=template&id=01056c7c&scoped=true&"
import script from "./requestVaccine.vue?vue&type=script&lang=js&"
export * from "./requestVaccine.vue?vue&type=script&lang=js&"
import style0 from "./requestVaccine.vue?vue&type=style&index=0&id=01056c7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01056c7c",
  null
  
)

export default component.exports